import createSagaMiddleWare from "redux-saga";
import { applyMiddleware, combineReducers, createStore, compose } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";

import rootSaga from "./sagas";
import ordersReducer from "./orders/reducer";
import locationsReducer from "./locations/reducer";
import menusReducer from "./menu/reducer";
import { generalsReducer } from "./generals/reducer";
import stopListReducer from "./stoplist/reducer";
import createMenuReducer from "./createMenu/reducer";
import menuListReducer from "./menulist/reducer";
import attributeReducer from "./attributes/reducer";
import { authReducer } from "./auth/reducer";
import ordersExcelReducer from "./ordersExcel/reducer";
import { callCenterReducer } from "./callcenter/reduer";
import settingsReducer from "./settings/reducer";
import { selectAllReducer } from "./selectAll/reducer";
import { appManagerReducer } from "./app_manager/reducer";
import attributesListSectionReducer from "@src/pages/ConfigureMenuPage/components/AttributesListSection/store/allAttributesListSectionReducer";

const sagaMiddleWare = createSagaMiddleWare();

const reducers = combineReducers({
  appManager: appManagerReducer,
  orders: ordersReducer,
  menus: menusReducer,
  locations: locationsReducer,
  generals: generalsReducer,
  stopLists: stopListReducer,
  createMenu: createMenuReducer,
  menuList: menuListReducer,
  attributes: attributeReducer,
  auth: authReducer,
  excel: ordersExcelReducer,
  callCenter: callCenterReducer,
  settings: settingsReducer,
  selectAll: selectAllReducer,
  attributesListSection: attributesListSectionReducer,
});
// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(applyMiddleware(sagaMiddleWare));

export const store = createStore(reducers, enhancer);

sagaMiddleWare.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;

// const middleware = [...getDefaultMiddleware({ thunk: false }), sagaMiddleWare];
